import React, { ChangeEvent, FocusEvent } from "react";
import "./Feedback.css";

interface LabelInputProps {
  label: string;
  type: string;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value?: string;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  min?: number;
  max?: number;
  required?: boolean;
}

const LabelInput: React.FC<LabelInputProps> = ({
  label,
  type,
  onChange,
  onBlur,
  value,
  maxLength,
  disabled,
  placeholder,
  min,
  max,
  required,
}) => {
  const handleFocus = () => {
    // Optional: focus logic
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!e.target.value) {
      onBlur && onBlur(e);
    }
  };

  return (
    <div>
      <label className="label-floating">
        {label}
        {required && <span className="required-asterisk"> *</span>}
      </label>{" "}
      {maxLength && maxLength >= 100 ? (
        <textarea
          className="input-floating-label input-feedback-textarea"
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={onChange}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          placeholder={placeholder}
        />
      ) : (
        <input
          autoComplete="off"
          className="input-floating-label"
          onFocus={handleFocus}
          onBlur={handleBlur}
          type={type}
          onChange={onChange}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          placeholder={placeholder}
          min={min}
          max={max}
        />
      )}
    </div>
  );
};

export default LabelInput;